import { render, staticRenderFns } from "./TrafficMessageYellowVestText.vue?vue&type=template&id=a49cbeba"
import script from "./TrafficMessageYellowVestText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageYellowVestText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports